import { PlugIcon } from 'lucide-react';
import { integrationInfo } from '../../data/insightIntegrations';
import type { IntegrationId } from '../../core/types/insights';

/**
 * Een bron die (nog) niet gekoppeld is: wat hij oplevert en de stappen. Nooit een lege grafiek.
 */
export function IntegrationEmpty({
  id,
  compact = false
}: {
  id: IntegrationId;
  compact?: boolean;
}) {
  const info = integrationInfo[id];
  return <section aria-label={`${info.name} koppelen`} className={`rounded-lg border border-dashed border-line bg-white/60 ${compact ? 'p-4' : 'p-5 sm:p-7'}`} data-id="element-1894" data-mp="2jrv34lhzkhbd">
      <div className="flex items-start gap-3" data-id="element-1895" data-mp="2eubqfq0xsclj">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-sand text-muted" aria-hidden="true" data-id="element-1896" data-mp="2a0qq3rbvf6j6">
          <PlugIcon className="h-4 w-4" strokeWidth={1.75} data-id="element-1897" data-mp="251w82rlq9m04" />
        </span>
        <div className="min-w-0" data-id="element-1898" data-mp="32i35h1dv33qi">
          <h3 className="text-[15px] font-medium text-ink" data-id="element-1899" data-mp="32j4fr3n1zm76">{info.name} is nog niet gekoppeld</h3>
          <p className="mt-1 max-w-xl text-[13px] leading-relaxed text-muted" data-id="element-1900" data-mp="2xps21ojwwzt7">{info.what}</p>
          {!compact && <ol className="mt-4 max-w-xl space-y-2 text-[13px] text-ink" data-id="element-1901" data-mp="qt2ko9qe5eh2">
              {info.steps.map((s, i) => <li key={s} className="flex gap-3" data-id="element-1902" data-mp="h16k8s0u1c9o" data-mpi={i}>
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-line text-[11px] tabular-nums text-muted" data-id="element-1903" data-mp="h0dlad847r23">{i + 1}</span>
                  <span className="leading-relaxed" data-id="element-1904" data-mp="7zyxn77ohzvf">{s}</span>
                </li>)}
            </ol>}
          {compact && <p className="mt-2 text-[12px] text-muted" data-id="element-1905" data-mp="c354oh2m7v2y">Hoe je hem koppelt, staat bij Inzicht › Bereik.</p>}
        </div>
      </div>
    </section>;
}